import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "../../../../../../Uri";
import { Container, Grid, InputLabel } from "@mui/material";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import MDTypography from "components/MDTypography";
import Textfield from "layouts/profile/GuestLoginForm/components/TextField";
import Select from "layouts/profile/GuestLoginForm/components/Select";
import Purpose from "./Purpose";
import DateTimePicker from "../../../../../profile/GuestLoginForm/components/DataTimePicker";
import Button from "layouts/profile/GuestLoginForm/components/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Backdrop, CircularProgress } from "@mui/material";
import "./GuestPaymentsinPopUp.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const useStyles = makeStyles({
  root: {
    height: 40,
  },
  size: {
    width: 40,
    height: 30,
  },
  gap: {
    paddingLeft: 20,
    height: 100,
  },
});

const notify = () => toast();

// Module-level guard: shared across all component instances (fixes double call in React Strict Mode)
let isSubmitting = false;

const ExceedPayments = (props) => {
  const due = Math.ceil(props.DueAmount);

  const FORM_VALIDATION = Yup.object().shape({
    paymentPurpose: Yup.string().required("Required"),
    amountPaid: Yup.number().required("Required"),
    transactionDate: Yup.date()
      .required("Required")
      .test(
        "Transaction date",
        "Please choose a valid transactionDate date 🥱🥳",
        (date) => moment().diff(moment(date), "years") <= 8
      ),
    transactionId: Yup.string()
      .test(
        "len",
        "can be empty or with string at least 10 characters and not more than 30",
        (val) => {
          if (val == undefined) {
            return true;
          }
          return val.length == 0 || (val.length >= 10 && val.length <= 30);
        }
      )
      .required("Required"),
  });

  const [disableButtons, setDisableButtons] = React.useState(false);
  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let userId = userData.data.userId;
  console.log(userId);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    console.log("toggled");
    setOpen(!open);
  };

  var GuestOccupancyType = props.guestdetails.occupancyType;
  var buildingId = props.guestdetails.buildingId;
  var GuestID = props.guestdetails.id;
  var INITIAL_FORM_STATE = {
    paymentPurpose: "",
    amountPaid: "",
    transactionId: "",
    guestId: GuestID,
    createdBy: userId,
    occupancyType: GuestOccupancyType,
    buildingId: buildingId,
    transactionDate: "",
  };
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <MDTypography gutterBottom>
          <h5 className="head-1-checkOut">Proceed To pay</h5>
        </MDTypography>
      </Grid>
      <Grid item xs={12}>
        <Container maxWidth="md">
          <div>
            <Formik
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={async (guest, { resetForm }) => {
                if (isSubmitting) return;
                isSubmitting = true;
                setDisableButtons(true);

                try {
                  console.log(guest, "submit function");
                  const res = await axios
                    .post("/payment/addAfterOnBoard", guest)
                    .catch((err) => {
                      toast.error("Server error");
                    });

                  console.log(res?.data, "after disable");
                  if (res?.data != null) {
                    props.editGuestHandler();
                    toast.success("Payment Recorded Successfully");
                    await axios
                      .put(
                        `/guest/planExtensionForDandR/${props.guestdetails.id}`
                      )
                      .then((res2) => {
                        console.log(res2.data);
                        toast.success(res2.data.body);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                  setTimeout(() => {
                    try {
                      resetForm();
                      setDisableButtons(true);
                    } catch {
                      console.log("error");
                    }
                  }, 50);
                } finally {
                  isSubmitting = false;
                  setDisableButtons(false);
                }
              }}
            >
              {(formProps) => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <h5>Amount Paid</h5>
                      <Textfield name="amountPaid" />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Transaction Id</h5>
                      <Textfield name="transactionId" />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Payment Purpose</h5>
                      <Select
                        IconComponent={() => (
                          <ArrowDropDownIcon className={classes.size} />
                        )}
                        name="paymentPurpose"
                        options={Purpose}
                        className={classes.root}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Transcation Date </h5>
                      <DateTimePicker
                        maxdate={new Date()}
                        name="transactionDate"
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <Button
                        type="submit"
                        style={{ align: "center" }}
                        disabled={disableButtons || formProps.isSubmitting}
                      >
                        Confirm Extension
                      </Button>
                    </Grid>
                  </Grid>
                  <ToastContainer
                    maxWidth="sx"
                    position="top-right"
                    autoClose={3000}
                    type="toast.TYPE.SUCCESS"
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </Form>
              )}
            </Formik>
          </div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ExceedPayments;
